// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;&#145;For see how the wicked bend the bow<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;and fit their arrows to the string,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;to shoot from the shadows at the true of heart.<br> </p> </div></div>";
// Exports
module.exports = code;